import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { DamageReport } from '../../models/damage-report';
import { GenericPaginated } from '../../models/generic-paginated';
import { Observable } from 'rxjs';
import { Generic } from '../../models/generic';

@Injectable({
  providedIn: 'root'
})
export class DamageReportsService {

  private baseUrl = environment.url;

  private http = inject(HttpClient)
  private addParamsService = inject(AddParamsService)

  getDamageReportsList = (params?: Params): Observable<GenericPaginated<DamageReport>> => {
    return this.http.get<GenericPaginated<DamageReport>>(`${this.baseUrl}/damage-reports`, {
      params: this.addParamsService.addParams(params)
    });
  }

  acknowledgeReport = (reportID: number): Observable<DamageReport> => {
    return this.http.post<DamageReport>(`${this.baseUrl}/damage-reports/${reportID}/acknowledge`, {});
  }

  rejectReport = (reportID: number, payload: object): Observable<DamageReport> => {
    return this.http.post<DamageReport>(`${this.baseUrl}/damage-reports/${reportID}/reject`, payload);
  }


  getDamageStats(): Observable<Generic<{ pending: number, acknowledged: number, rejected: number }>> {
    return this.http.get<Generic<{ pending: number, acknowledged: number, rejected: number }>>(
      `${this.baseUrl}/damage-reports/statistics`
    );
  }
}
